var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAddArtist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "95.468%",
    x2: "0%",
    y2: "4.532%",
    id: "xhcor4nwoa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FD8CC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.72 0h7.722c5.098 0 7.221.585 9.275 1.683a11.449 11.449 0 0 1 4.763 4.763c1.098 2.053 1.683 4.176 1.683 9.274v5.906c0 5.097-.585 7.22-1.683 9.274a11.449 11.449 0 0 1-4.763 4.763c-2.054 1.098-4.177 1.683-9.275 1.683H15.72c-5.098 0-7.22-.585-9.274-1.683A11.449 11.449 0 0 1 1.683 30.9C.585 28.846 0 26.723 0 21.626V15.72c0-5.098.585-7.22 1.683-9.274a11.449 11.449 0 0 1 4.763-4.763C8.499.585 10.622 0 15.72 0z",
    fill: "url(#xhcor4nwoa)",
    transform: "translate(.613 .35)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Comfortaa-Medium, Comfortaa",
    fontSize: 25.2,
    fontWeight: 400,
    fill: "#FFF",
    transform: "translate(.613 .35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12.544,
    y: 27.769
  }, "+")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddArtist);
export default __webpack_public_path__ + "static/media/ic_add_artist.dac0943f3839ef05eda719e58462c328.svg";
export { ForwardRef as ReactComponent };